// components/chat/chat-input/AttachmentPreview.tsx
import { X, FileText } from "lucide-react";

export const AttachmentPreview = ({
  file,
  onRemove,
}: {
  file: File;
  onRemove: () => void;
}) => {
  return (
    <div className="relative inline-flex items-center gap-2 rounded-lg px-3 py-2 bg-background border">
      
      {/* Icon */}
      <div className="flex h-9 w-9 items-center justify-center rounded-sm bg-amber-100">
        <FileText className="h-4 w-4 text-amber-600" />
      </div>

      {/* Name + type */}
      <div className="flex min-w-0 flex-col">
        <span className="max-w-[150px] truncate text-sm font-medium">
          {file.name}
        </span>
        <span className="text-xs uppercase text-muted-foreground">
          {file.type.split("/")[1] || "file"}
        </span>
      </div>

      {/* Remove */}
      <button
        className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center
                  rounded-full bg-foreground text-background border border-white"
        onClick={onRemove}
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
};
